import $ from "jquery";
import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/Cuesheets/AmendmentHistoryStore';
import { toFormattedDate } from '../../tools/toolkit';
import { LoadingBar } from "../Controls/LoadingBar";
import ModalDialogError from '../Controls/ModalDialogError';
import { isHtmlLink } from "../../tools/validator";

var programmeId;

class AmendmentHistory extends React.Component {

    componentWillMount() {

        programmeId = this.props.match.params['programmeId'];

        if (programmeId) {
            this.props.getAmendmentHistory(programmeId);
        }

    }

    handleErrorDialogClose = () => {

        this.props.clearErrorMessage();

    }

    render() {
        return (
            <div className='card mt-3'>
                <div className='container-fluid p-4'>
                    <div className='row'>
                        <h3>Amendment History</h3>
                    </div>
                    <div className='row publicationLogContent'>
                        {(this.props.isLoading ? '' : this.renderListTable())}
                    </div>
                </div>
                <ModalDialogError id='errorModalDialog' errorData={this.props.errorData} onCloseClick={this.handleErrorDialogClose} hasErrorOccured={this.props.hasErrorOccured} />
                <LoadingBar isLoading={this.props.isLoading} />
            </div>
        );
    }

    renderListTable() {
        return (
            <table className='table'>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Society</th>
                        <th>Sent Status</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.lists.map(item =>
                        <tr key={item.id}>
                            <td>{toFormattedDate(item.dateSent)}</td>
                            <td>{this.renderIdentifier(item.society.name)}</td>
                            <td>{item.sentToSocietyStatus.name}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    renderIdentifier(identifier) {
        let isLink = isHtmlLink(identifier);
        let shortIdentifier = identifier.length > 70 ? identifier.substring(0, 70) + '...' : identifier;

        if (isLink) {
            return (
                <NavLink data-toggle='tooltip' data-placement='bottom' title={identifier}
                    to={identifier.toLowerCase().lastIndexOf('www', 0) === 0 ? 'http://' + identifier : identifier} target='_blank' >
                    {shortIdentifier}
                </NavLink>
            );
        }
        return (
            <span data-toggle='tooltip' data-placement='bottom' title={identifier}>{shortIdentifier}</span>
        );
    }
}

export default connect(
    state => state.amendmentHistory,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(AmendmentHistory);


// WEBPACK FOOTER //
// ./src/components/Cuesheets/AmendmentHistory.js